"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const moment_1 = __importDefault(require("moment"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialState = {
    searchOptionsStates: initialSearchOptionsState(),
    includeMno: false,
    // canSearch: false,
    searchResults: false,
    currentSearchSelections: {
        filterOptions: [],
        includeMno: false
    },
    resultState: undefined
};
function initialSearchOptionsState() {
    const initialStartDate = (0, moment_1.default)().subtract({ days: 7 });
    const initialEndDate = (0, moment_1.default)();
    const baseState = {
        groupBy: false,
        useFilter: false
    };
    return [
        Object.assign(Object.assign({ type: "status" }, baseState), { selectedStatus: [] }),
        Object.assign(Object.assign({ type: "date" }, baseState), { selectedStartDateStringified: initialStartDate.format("YYYY-MM-DD"), selectedEndDateStringified: initialEndDate.format("YYYY-MM-DD") }),
        Object.assign({ type: "deleted", selectedDeletedOptions: [] }, baseState),
        Object.assign(Object.assign({ type: "users" }, baseState), { selectedUsers: "" })
    ];
}
function reducer(state = initialState, action) {
    const type = action.type;
    switch (type) {
        case "mlc-usage-statistics/TOGGLE_SEARCH_RESULTS": {
            return Object.assign(Object.assign({}, state), { searchResults: true, 
                // resultState: !state.resultState
                //   ? Result.initialState
                //   : state.resultState,
                currentSearchSelections: {
                    filterOptions: state.searchOptionsStates,
                    includeMno: state.includeMno
                } });
        }
        case "mlc-usage-statistics/SET_FILTER_OPTIONS_STATE": {
            return Object.assign(Object.assign({}, state), { searchOptionsStates: action.filterOptionsState });
        }
        case "mlc-usage-statistics/TOGGLE_INCLUDE_MNO": {
            return Object.assign(Object.assign({}, state), { includeMno: !state.includeMno });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(type);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map